import { unwrapNodes } from '@udecode/plate';
import { Location } from 'slate';
import { LinkElement } from '../nodes/LinkElement';

export const unwrapLink = (editor, at: Location) => {
  unwrapNodes(editor, {
    match: { type: LinkElement.type },
    at,
  });
};
